export enum StoreModules {
	Rights = 'Rights',
	Router = 'Router',
	CtsDistribution = 'CtsDistribution',
}
